/* eslint-disable */
import {
  SET_USER,
  SET_LOCALE,
} from './user_constants';

const initialState = {
  email: null,
  admin: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        email: action.payload.email,
        admin: action.payload.admin
      };
    case SET_LOCALE:
      return {
        ...state,
        locale: action.payload,
      };
    default:
      return state;
  }
}
